import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import SidebarSection from './SidebarSection';
import { NoDataText } from './SidebarSection';
import { userAPI } from '../../api';

const RankList = styled.ul`
  display: flex;
  flex-direction: column;
`;

const RankItem = styled.li`
  display: flex;
  align-items: center;
  padding: 0.375rem 0;
  border-bottom: 1px solid #f3f4f6;
  
  &:last-child {
    border-bottom: none;
  }
`;

const RankNumber = styled.span`
  font-weight: 700;
  color: #ef4444;
  width: 1.5rem;
  text-align: center;
  font-size: 0.8rem;
`;

const RankUser = styled.span`
  color: #111827;
  font-size: 0.8rem;
  flex: 1;
`;

const RankPoints = styled.span`
  color: #ef4444;
  font-weight: 500;
  font-size: 0.8rem;
`;

const LoadingText = styled.div`
  color: #6b7280;
  font-size: 0.8rem;
  text-align: center;
  padding: 0.5rem 0;
`;

const ErrorText = styled.div`
  color: #ef4444;
  font-size: 0.8rem;
  text-align: center;
  padding: 0.5rem 0;
`;

interface RankUser {
  id: number;
  username: string;
  points: number;
}

const PointRankingSection: React.FC = () => {
  const [pointRanking, setPointRanking] = useState<RankUser[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await userAPI.getPointRanking();
        if (response.data.success) {
          setPointRanking(response.data.data);
        } else {
          setError(response.data.message || '랭킹 데이터를 불러오는 중 오류가 발생했습니다.');
          setPointRanking([]);
        }
      } catch (error) {
        console.error('랭킹 데이터 로딩 오류:', error);
        setError('랭킹 데이터를 불러오는 중 오류가 발생했습니다.');
        setPointRanking([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRanking();
  }, []);

  return (
    <SidebarSection title="포인트 랭킹" moreLink="/ranking">
      {loading ? (
        <LoadingText>랭킹 데이터 로딩중...</LoadingText>
      ) : error ? (
        <ErrorText>{error}</ErrorText>
      ) : pointRanking.length > 0 ? (
        <RankList>
          {pointRanking.map((user, index) => (
            <RankItem key={user.id}>
              <RankNumber>{index + 1}</RankNumber>
              <RankUser>{user.username}</RankUser>
              <RankPoints>{user.points.toLocaleString()}P</RankPoints>
            </RankItem>
          ))}
        </RankList>
      ) : (
        <NoDataText>랭킹 데이터가 없습니다.</NoDataText>
      )}
    </SidebarSection>
  );
};

export default PointRankingSection; 